<template>
    <el-dialog
        title="搜索字段设置"
        width="688px"
        :close-on-click-modal="false"
        :visible.sync="showDialog"
        :before-close="hideDialog"
        :append-to-body="true"
        >
        <el-transfer
            v-model="targetValues"
            :props="{key: 'id', label: 'value'}"
            :data="searchSchema"
            :filterable="true"
            :filter-method="filterMethod"
            filter-placeholder="输入关键字"
            :button-texts="['删除', '添加']"
            :titles="['可选字段', '已选字段']">
        </el-transfer>
        <span slot="footer">
            <el-button @click="hideDialog">取消</el-button>
            <el-button type="primary" @click="confirmSearchSchema">确定</el-button>
        </span>
    </el-dialog>
    
</template>
<script>
import { mapGetters,mapActions, mapMutations } from 'vuex';

export default {
    props: {
        showDialog: Boolean,
    },
    data() {
        return {
            targetValues: []
        }
    },
    methods: {
        ...mapMutations('commonsearch', [
            'setCurrentSearchSchema',
        ]),
          ...mapActions('schema', [
            'get_my_schema_list',
        ]),
        hideDialog() {
            this.$emit('update:showDialog', false);
        },
        // 过滤选项
        filterMethod(query, item) {
            return !!(item.value && (item.value.indexOf(query) > -1));
        },
        // 修改搜索字段
        confirmSearchSchema() {
            let newSchema = {...this.currentSearchSchema};
            if(this.targetValues.length > 0) {
                newSchema.cols = this.searchSchema.filter((item) => {
                    return this.targetValues.findIndex((obj) => {
                        return item.id == obj;
                    }) > -1;
                });
            } else {
                newSchema.cols = [];
            }
            
            this.setCurrentSearchSchema(newSchema);
            this.hideDialog();
        },
        loadAll() {
         
            // 加载当前字段配置
            let schema = this.currentSearchSchema.cols || [];
            schema = schema.map((item) => {
                return item.id;
            });
            this.targetValues = schema;
        }
    },
    watch: {
        currentSearchSchema: function(newValue) {
            let schema = newValue.cols || [];
            schema = schema.map((item) => {
                return item.id;
            });
            this.targetValues = schema;
        }
    },
    computed: {
        ...mapGetters('commonsearch', [
            'searchSchema',
            'currentSearchSchema',
        ]),
    },
    created() {
        this.loadAll();
    }
}
</script>
<style>
 .el-dialog .el-transfer .el-input{  width: auto !important; }
</style>